import React from "react";
import locationIcon from "../../Assets/location-icon.svg";

const ContactUs = () => {
  // Phone icon SVG
  const PhoneIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22 16.92V19.92C22.0011 20.1985 21.9441 20.4742 21.8325 20.7292C21.7209 20.9842 21.5573 21.2131 21.3522 21.4011C21.1471 21.5891 20.9053 21.7319 20.6441 21.8197C20.3829 21.9075 20.1085 21.9381 19.8372 21.9092C16.7432 21.5111 13.7621 20.4168 11.19 18.72C8.77382 17.1877 6.72533 15.1392 5.193 12.723C3.48997 10.1416 2.39496 7.15099 2 4.048C1.97108 3.77677 2.00164 3.50242 2.08944 3.24123C2.17724 2.98004 2.32005 2.73826 2.50805 2.53319C2.69605 2.32812 2.92493 2.16452 3.17993 2.05291C3.43493 1.9413 3.71064 1.88426 3.989 1.885H6.989C7.37849 1.88506 7.75706 2.02 8.05996 2.268C8.36286 2.516 8.57174 2.86218 8.652 3.248C8.82974 4.12519 9.11231 4.97795 9.493 5.788C9.654 6.147 9.707 6.543 9.647 6.93C9.587 7.317 9.416 7.68 9.155 7.98L7.755 9.38C9.16141 11.7265 11.0735 13.6386 13.42 15.045L14.82 13.645C15.12 13.384 15.483 13.213 15.87 13.153C16.257 13.093 16.653 13.146 17.012 13.307C17.822 13.6877 18.6748 13.9703 19.552 14.148C19.9378 14.2283 20.2839 14.4372 20.5319 14.7401C20.7799 15.043 20.9148 15.4216 20.915 15.811L22 16.92Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  const inputClasses = "w-full h-[48px] px-4 rounded-[12px] bg-transparent border border-[#2A2A2A] text-white placeholder-[#666666] focus:outline-none focus:border-[#17BD3B] transition-colors font-['Poppins'] text-[14px]";
  const labelClasses = "block mb-2 text-white text-[14px] font-['Poppins'] font-normal";

  return (
    <div className="bg-[#0A0A0A] min-h-screen text-white font-['Poppins']">
      <div className="pt-[120px] px-4 sm:px-6 lg:px-[120px] pb-20">
        <div className="max-w-[1200px] mx-auto">

          {/* Heading */}
          <h1 className="text-[40px] font-semibold mb-12 text-white font-['Poppins']">
            Contact Us
          </h1>

          <div className="flex flex-col lg:flex-row gap-12 items-start">

            {/* Left Section - Contact Info Cards */}
            <div className="w-full lg:w-[380px] flex flex-col gap-6 flex-shrink-0">

              {/* Visit Us Card */}
              <div className="bg-[#111111] rounded-2xl p-8 flex flex-col gap-3 border border-[#1F1F1F]">
                <div className="flex items-center gap-3 mb-1">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <img src={locationIcon} alt="Location" className="w-full h-full" />
                  </div>
                  <h3 className="text-[20px] font-semibold text-white font-['Poppins']">Visit us</h3>
                </div>
                <p className="text-[#B3B3B3] text-[14px] font-['Poppins'] leading-[21px]">
                  Visit us at our office—just a click away!
                </p>
                <a href="mailto:fusshn.business@gmail.com" className="text-[#17BD3B] text-[14px] hover:underline font-medium font-['Poppins']">
                  fusshn.business@gmail.com
                </a>
              </div>

              {/* Give us a call Card */}
              <div className="bg-[#111111] rounded-2xl p-8 flex flex-col gap-3 border border-[#1F1F1F]">
                <div className="flex items-center gap-3 mb-1">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <PhoneIcon />
                  </div>
                  <h3 className="text-[20px] font-semibold text-white font-['Poppins']">Give us a call</h3>
                </div>
                <p className="text-[#B3B3B3] text-[14px] font-['Poppins'] leading-[21px]">
                  Need call routing help? We're here.
                </p>
                <a href="tel:+919310824206" className="text-[#17BD3B] text-[14px] hover:underline font-medium font-['Poppins']">
                  +91 931 082 4206
                </a>
              </div>

            </div>

            {/* Right Section - Form */}
            <div className="w-full lg:flex-1">
              <form className="space-y-6">

                {/* First Name & Last Name */}
                <div className="flex flex-col sm:flex-row gap-6">
                  <div className="w-full sm:w-1/2">
                    <label className={labelClasses}>First Name<span className="text-red-500 ml-1">*</span></label>
                    <input type="text" placeholder="Enter your First Name" className={inputClasses} />
                  </div>
                  <div className="w-full sm:w-1/2">
                    <label className={labelClasses}>Last Name<span className="text-red-500 ml-1">*</span></label>
                    <input type="text" placeholder="Enter your Last Name" className={inputClasses} />
                  </div>
                </div>

                {/* Email & Mobile Number */}
                <div className="flex flex-col sm:flex-row gap-6">
                  <div className="w-full sm:w-1/2">
                    <label className={labelClasses}>Email</label>
                    <input type="email" placeholder="Enter your Email" className={inputClasses} />
                  </div>
                  <div className="w-full sm:w-1/2">
                    <label className={labelClasses}>Mobile Number<span className="text-red-500 ml-1">*</span></label>
                    <input type="tel" placeholder="Enter your Mobile Number" className={inputClasses} />
                  </div>
                </div>

                {/* Message */}
                <div>
                  <label className={labelClasses}>Message<span className="text-red-500 ml-1">*</span></label>
                  <textarea
                    placeholder="Enter your Message"
                    rows={4}
                    className="w-full px-4 py-3 rounded-[12px] bg-transparent border border-[#2A2A2A] text-white placeholder-[#666666] resize-none focus:outline-none focus:border-[#17BD3B] transition-colors font-['Poppins'] text-[14px]"
                  ></textarea>
                </div>

                {/* Checkbox */}
                <div className="flex items-center gap-3">
                  <div className="relative flex items-center">
                    <input
                      type="checkbox"
                      id="heading"
                      className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-[#333333] bg-transparent checked:border-[#17BD3B] checked:bg-[#17BD3B] transition-all"
                    />
                    <svg className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-3.5 h-3.5 pointer-events-none opacity-0 peer-checked:opacity-100 transition-opacity" viewBox="0 0 14 14" fill="none">
                      <path d="M11.6666 3.5L5.24992 9.91667L2.33325 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <label htmlFor="heading" className="text-[14px] cursor-pointer text-[#B3B3B3] font-['Poppins'] select-none">
                    Change your heading
                  </label>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="w-full bg-[#17BD3B] hover:bg-[#15a834] text-white font-semibold py-4 rounded-[12px] transition-all duration-300 shadow-lg shadow-[#17BD3B]/20 text-[16px] font-['Poppins']"
                >
                  Submit
                </button>

              </form>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
